import React from 'react'

import { ProfileTitle } from './ProfileComponents.tsx'
import { FormattedMessage } from 'react-intl'
export const ProfileNotifications = () => {
  return (
    <ProfileTitle
      title={<FormattedMessage id="user.notifications" />}
    />
  )
}
